import { render, staticRenderFns } from "./riskAlert.vue?vue&type=template&id=cb8a4b60&"
import script from "./riskAlert.vue?vue&type=script&lang=js&"
export * from "./riskAlert.vue?vue&type=script&lang=js&"
import style0 from "./riskAlert.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports